namespace GeniuzPOS.Common.Report {
    export interface BaseTaxReportHeader extends Serenity.ListRequest {
        BizName?: string;
        ShopName?: string;
        ShopAddress?: string;
        ShopTaxId?: string;
        BranchName?: string;
    }
}
